<template>
	<div
		:class="[
			`${baseClass}`,
			{
				[`${baseClass}--disabled`]: disabled
			}
		]"
	>
		<button
			type="button"
			:class="`${baseClass}-minus`"
			:disabled="disabled || locked || quantity <= min"
			@click.prevent="$emit('sub')"
		>
			<SVGMinus/>
		</button>
		<span
			:class="`${baseClass}-value`"
			v-html="quantity"
		/>
		<button
			type="button"
			:class="`${baseClass}-plus`"
			:disabled="disabled || locked || quantity >= max"
			@click.prevent="$emit('add')"
		>
			<SVGPlus/>
		</button>
	</div>
</template>

<script>
export default {
	props: {
		baseClass: String,
		quantity: Number,
		disabled: Boolean,
		locked: Boolean,
		min: {
			type: Number,
			default: 0,
		},
		max: {
			type: Number,
			default: Infinity,
		},
	},
}
</script>

<style>

</style>
